// src/pages/HomePage.js
import "./HomePage.css";

// Images
import PlayStore from "../../assets/images/PlayStore.png";
import AppStore from "../../assets/images/AppStore.png";
import Phone from "../../assets/images/ph.png";
import Phone1 from "../../assets/images/ph4.png";


const HomePage = () => {
  return (
    
    <div>
      <div className="container-fluid pt-5  hero-header mb-0">
        <div className="container pt-5">
          <div className="row g-5 pt-5">
            <div className="col-lg-6 align-self-center text-center text-lg-start mb-lg-5">
              <h1 className="display-4 text-white mb-4 animated ">
                The Ultimate Super App for All Your Daily Essentials.
              </h1>
              <p className="text-white mb-4 animated ">
                From sending bulk SMS, delivering goods, requesting rides, to
                buying airtime and data, and even shopping for you – everything
                in one place, saving you time and money!.
              </p>
              <a href="" className="btn    me-3 animated ">
                <img
                  src={PlayStore}
                  alt="logo"
                  className="logo-image"
                  style={{
                    width: "180px",
                    height: "auto",
                    objectFit: "contain",
                  }}
                ></img>
              </a>
              <a href="" className="btn   me-3 animated ">
                <img
                  src={AppStore}
                  alt="logo"
                  className="logo-image"
                  style={{
                    width: "180px",
                    height: "auto",
                    objectFit: "contain",
                  }}
                ></img>
              </a>
            </div>
            <div className="col-lg-6 align-self-end text-center text-lg-end">
              <img className="img-fluid" src={Phone} alt="" />
            </div>
          </div>
        </div>
      </div>
      <div className="container-fluid pt-5 mt-2">
        <div className="container pt-5">
          <div
            className="mx-auto text-center wow fadeIn"
            data-wow-delay="0.1s"
            style={{ maxWidth: "500px" }}
          >
            <div className="btn btn-sm   px-3 mb-3" id="features">
              {" "}
              Features
            </div>
            <h1 className="mb-4">
              Features of the Super App that Powers Your Everyday Needs
            </h1>
          </div>
          <div className="row g-4">
           

            <div className="col-md-4 d-flex">
              <div
                className="card text-center border-0 shadow flex-fill"
                style={{ borderRadius: "15px" }}
              >
                <div className="card-body d-flex flex-column">
                  <div className="icon mb-3">
                    <div
                      className="rounded-circle p-4 mx-auto"
                      style={{
                        background: "linear-gradient(to top, #007bff, #0764c4)",
                        width: "80px",
                        height: "80px",
                        color: "white",
                      }}
                    >
                      <i className="fas fa-box fa-2x"></i>
                    </div>
                  </div>
                  <h5 className="card-title">Delivery</h5>
                  <p className="card-text">
                    Fast and affordable delivery services right to your
                    doorstep.
                  </p>
                  <div className="mt-auto"></div>
                </div>
              </div>
            </div>

     
            <div className="col-md-4 d-flex">
              <div
                className="card text-center border-0 shadow flex-fill"
                style={{ borderRadius: "15px" }}
              >
                <div className="card-body d-flex flex-column">
                  <div className="icon mb-3">
                    <div
                      className="rounded-circle p-4 mx-auto"
                      style={{
                        background: "linear-gradient(to top, #fb571c, #fa7a1e)",
                        width: "80px",
                        height: "80px",
                        color: "white",
                      }}
                    >
                      <i className="fas fa-car fa-2x"></i>
                    </div>
                  </div>
                  <h5 className="card-title">Ride</h5>
                  <p className="card-text">
                    Quick and comfortable ride services to get you where you
                    need to be.
                  </p>
                  <div className="mt-auto"></div>
                </div>
              </div>
            </div>

        
            <div className="col-md-4 d-flex">
              <div
                className="card text-center border-0 shadow flex-fill"
                style={{ borderRadius: "15px" }}
              >
                <div className="card-body d-flex flex-column">
                  <div className="icon mb-3">
                    <div
                      className="rounded-circle p-4 mx-auto"
                      style={{
                        background: "linear-gradient(to top, #007bff, #0764c4)",
                        width: "80px",
                        height: "80px",
                        color: "white",
                      }}
                    >
                      <i className="fas fa-shopping-cart fa-2x"></i>
                    </div>
                  </div>
                  <h5 className="card-title">Buy for Me</h5>
                  <p className="card-text">
                    Let us shop for you, with seamless tracking and delivery.
                  </p>
                  <div className="mt-auto"></div>
                </div>
              </div>
            </div>


            <div className="col-md-4 d-flex">
              <div
                className="card text-center border-0 shadow flex-fill"
                style={{ borderRadius: "15px" }}
              >
                <div className="card-body d-flex flex-column">
                  <div className="icon mb-3">
                    <div
                      className="rounded-circle p-4 mx-auto"
                      style={{
                        background: "linear-gradient(to top, #fb571c, #fa7a1e)",
                        width: "80px",
                        height: "80px",
                        color: "white",
                      }}
                    >
                      <i className="fas fa-mobile-alt fa-2x"></i>
                    </div>
                  </div>
                  <h5 className="card-title">Buy Airtime</h5>
                  <p className="card-text">
                    Instantly buy airtime for all networks at the best prices.
                  </p>
                  <div className="mt-auto"></div>
                </div>
              </div>
            </div>

            {/* Card 5 */}
            <div className="col-md-4 d-flex">
              <div
                className="card text-center border-0 shadow flex-fill"
                style={{ borderRadius: "15px" }}
              >
                <div className="card-body d-flex flex-column">
                  <div className="icon mb-3">
                    <div
                      className="rounded-circle p-4 mx-auto"
                      style={{
                        background: "linear-gradient(to top, #007bff, #0764c4)",
                        width: "80px",
                        height: "80px",
                        color: "white",
                      }}
                    >
                      <i className="fas fa-signal fa-2x"></i>
                    </div>
                  </div>
                  <h5 className="card-title">Buy Data</h5>
                  <p className="card-text">
                    Purchase data bundles quickly and conveniently.
                  </p>
                  <div className="mt-auto"></div>
                </div>
              </div>
            </div>

            
            <div className="col-md-4 d-flex">
              <div
                className="card text-center border-0 shadow flex-fill"
                style={{ borderRadius: "15px" }}
              >
                <div className="card-body d-flex flex-column">
                  <div className="icon mb-3">
                    <div
                      className="rounded-circle p-4 mx-auto"
                      style={{
                        background: "linear-gradient(to top, #fb571c, #fa7a1e)",
                        width: "80px",
                        height: "80px",
                        color: "white",
                      }}
                    >
                      <i className="fas fa-envelope fa-2x"></i>
                    </div>
                  </div>
                  <h5 className="card-title">Bulk SMS</h5>
                  <p className="card-text">
                    Efficient and reliable bulk SMS service for businesses and
                    individuals.
                  </p>
                  <div className="mt-auto"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

     
      <div className="container-fluid  chooseUs " id="mission">
        <div className="container pt-5">
          <div className="row g-5">
            <div
              className="col-lg-6 align-self-center mb-md-5 pb-md-5 wow fadeIn"
              data-wow-delay="0.3s"
            >
              <div className="btn btn-sm fw-bold text-white fs-3 mb-1">
                Our Mission
              </div>
              <p className="text-white mb-4">
              To simplify and enhance daily tasks for individuals and businesses by providing an efficient, reliable, and all-encompassing digital platform for essential services.
              </p>
              <div className="btn btn-sm fw-bold text-white fs-3 mb-1 mt-2">
                Our Core Values
              </div>

              <p className="text-light mb-4">
                We offer state-of-the-art SMS services designed to deliver your
                messages efficiently and reliably, ensuring your communication
                is always on point.
              </p>
              <div className="d-flex align-items-center text-white mb-3">
                <div className="btn-sm-square bg-white text-color rounded-circle me-3">
                  <i className="fa fa-check"></i>
                </div>
                <span>Fast and Dependable Delivery</span>
              </div>
              <div className="d-flex align-items-center text-white mb-3">
                <div className="btn-sm-square bg-white text-color rounded-circle me-3">
                  <i className="fa fa-check"></i>
                </div>
                <span>Flexible and Customer-Centric</span>
              </div>
              <div className="d-flex align-items-center text-white mb-3">
                <div className="btn-sm-square bg-white text-color rounded-circle me-3">
                  <i className="fa fa-check"></i>
                </div>
                <span>High Security Standards </span>
              </div>
              <div className="d-flex align-items-center text-white mb-3">
                <div className="btn-sm-square bg-white text-color rounded-circle me-3">
                  <i className="fa fa-check"></i>
                </div>
                <span>Seamless Integration</span>
              </div>
              <div className="d-flex align-items-center text-white mb-3">
                <div className="btn-sm-square bg-white text-color rounded-circle me-3">
                  <i className="fa fa-check"></i>
                </div>
                <span>Dedicated Customer Support</span>
              </div>
            </div>
            <div
              className="col-lg-6 align-self-end text-center text-md-end wow fadeIn"
              data-wow-delay="0.5s"
            >
              <img className="img-fluid happy" src={Phone1} alt="" />
            </div>
          </div>
        </div>
      </div>

      <div className="container-fluid dowload " id="dowload">
        <div className="container ">
          <div className="container d-flex justify-content-center align-items-center text-center my-3">
            <div className="row justify-content-center">
              <div className="col-12 col-md-10 col-lg-8 px-4">
                <h1 className="fw-bold mb-3">
                  Messages will be sent and received, but wouldn't it be great
                  to have more control over your communication?
                </h1>
                <p className="lead">
                  Our platform ensures your messages, rides, and deliveries
                  reach their destinations efficiently. With our tools, you can
                  manage your services seamlessly, empowering you to communicate
                  and connect better
                </p>
                <a href="" className="btn    me-3 animated ">
                  <img
                    src={PlayStore}
                    alt="logo"
                    className="logo-image"
                    style={{
                      width: "180px",
                      height: "auto",
                      objectFit: "contain",
                    }}
                  ></img>
                </a>
                <a href="" className="btn   me-3 animated ">
                  <img
                    src={AppStore}
                    alt="logo"
                    className="logo-image"
                    style={{
                      width: "180px",
                      height: "auto",
                      objectFit: "contain",
                    }}
                  ></img>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="container-fluid mt-4" id="faq">
        <div className="container ">
          <div className="mx-auto text-center wow fadeIn" data-wow-delay="0.1s">
            <div className="btn btn-sm px-3 mb-3">Popular FAQs</div>
            <h1 className="mb-4">Frequently Asked Questions</h1>
          </div>
          <div className="row">
            <div className="col-lg-6">
              <div className="accordion" id="accordionFAQ1">
                <div
                  className="accordion-item wow fadeIn"
                  data-wow-delay="0.1s"
                >
                  <h2 className="accordion-header" id="headingOne">
                    <button
                      className="accordion-button collapsed "
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#collapseOne"
                      aria-expanded="false"
                      aria-controls="collapseOne"
                    >
                      What is KLIQ?
                    </button>
                  </h2>
                  <div
                    id="collapseOne"
                    className="accordion-collapse collapse"
                    aria-labelledby="headingOne"
                  >
                    <div className="accordion-body">
                    KLIQ is an all-in-one platform designed to simplify essential services such as deliveries, personal shopping (Buy for Me), utility payments, bulk SMS messaging, and smart waste management. It connects users with various services, allowing them to manage multiple tasks seamlessly in one place.
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-lg-6">
              <div className="accordion" id="accordionFAQ2">
                <div
                  className="accordion-item wow fadeIn"
                  data-wow-delay="0.5s"
                >
                  <h2 className="accordion-header" id="headingFive">
                    <button
                      className="accordion-button collapsed"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#collapseFive"
                      aria-expanded="false"
                      aria-controls="collapseFive"
                    >
                      How does KLIQ's delivery service work?
                    </button>
                  </h2>
                  <div
                    id="collapseFive"
                    className="accordion-collapse collapse"
                    aria-labelledby="headingFive"
                  >
                    <div className="accordion-body">
                    KLIQ's delivery service allows users to book deliveries for packages, groceries, or other items directly through the app. Simply enter the delivery details, and a courier will handle the pickup and drop-off efficiently.
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-lg-6">
              <div className="accordion" id="accordionFAQ4">
                <div
                  className="accordion-item wow fadeIn"
                  data-wow-delay="0.5s"
                >
                  <h2 className="accordion-header" id="headingFour">
                    <button
                      className="accordion-button collapsed"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#collapseFour"
                      aria-expanded="false"
                      aria-controls="collapseFour"
                    >
                      What is the "Buy for Me" feature?
                    </button>
                  </h2>
                  <div
                    id="collapseFour"
                    className="accordion-collapse collapse"
                    aria-labelledby="headingFour"
                  >
                    <div className="accordion-body">
                    The "Buy for Me" feature enables users to request specific items (e.g., groceries, electronics, clothing) that will be purchased and delivered to their doorstep. It's perfect for those who need help shopping for specific items but don’t have the time to do it themselves.
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-lg-6">
              <div className="accordion" id="accordionFAQ4">
                <div
                  className="accordion-item wow fadeIn"
                  data-wow-delay="0.5s"
                >
                  <h2 className="accordion-header" id="headingFour">
                    <button
                      className="accordion-button collapsed"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#collapseFour"
                      aria-expanded="false"
                      aria-controls="collapseFour"
                    >
                      Can I pay my utility bills through KLIQ?
                    </button>
                  </h2>
                  <div
                    id="collapseFour"
                    className="accordion-collapse collapse"
                    aria-labelledby="headingFour"
                  >
                    <div className="accordion-body">
                    The Bulk SMS feature lets users send mass text messages to a list of contacts. This is particularly useful for businesses and organizations looking to communicate with large groups of people efficiently, whether for promotions, alerts, or general updates.
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="accordion" id="accordionFAQ4">
                <div
                  className="accordion-item wow fadeIn"
                  data-wow-delay="0.5s"
                >
                  <h2 className="accordion-header" id="headingFour">
                    <button
                      className="accordion-button collapsed"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#collapseFour"
                      aria-expanded="false"
                      aria-controls="collapseFour"
                    >
                      How do I register on KLIQ?
                    </button>
                  </h2>
                  <div
                    id="collapseFour"
                    className="accordion-collapse collapse"
                    aria-labelledby="headingFour"
                  >
                    <div className="accordion-body">
                    To register on KLIQ, simply download the app, fill in your basic details, and verify your account. Once registered, you can start using KLIQ’s services immediately.
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="accordion" id="accordionFAQ4">
                <div
                  className="accordion-item wow fadeIn"
                  data-wow-delay="0.5s"
                >
                  <h2 className="accordion-header" id="headingFour">
                    <button
                      className="accordion-button collapsed"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#collapseFour"
                      aria-expanded="false"
                      aria-controls="collapseFour"
                    >
                      Is KLIQ available in my area?
                    </button>
                  </h2>
                  <div
                    id="collapseFour"
                    className="accordion-collapse collapse"
                    aria-labelledby="headingFour"
                  >
                    <div className="accordion-body">
                    KLIQ is currently available in select regions, but we are expanding our services rapidly. You can check the app or website for service availability in your location.
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="accordion" id="accordionFAQ4">
                <div
                  className="accordion-item wow fadeIn"
                  data-wow-delay="0.5s"
                >
                  <h2 className="accordion-header" id="headingFour">
                    <button
                      className="accordion-button collapsed"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#collapseFour"
                      aria-expanded="false"
                      aria-controls="collapseFour"
                    >
                      Can businesses use KLIQ?
                    </button>
                  </h2>
                  <div
                    id="collapseFour"
                    className="accordion-collapse collapse"
                    aria-labelledby="headingFour"
                  >
                    <div className="accordion-body">
                    Yes! KLIQ is designed to serve both individuals and businesses. Businesses can use features like delivery services, bulk SMS messaging, and utility payments to streamline their operations and communication.
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="accordion" id="accordionFAQ4">
                <div
                  className="accordion-item wow fadeIn"
                  data-wow-delay="0.5s"
                >
                  <h2 className="accordion-header" id="headingFour">
                    <button
                      className="accordion-button collapsed"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#collapseFour"
                      aria-expanded="false"
                      aria-controls="collapseFour"
                    >
                      What makes KLIQ different from other service apps?
                    </button>
                  </h2>
                  <div
                    id="collapseFour"
                    className="accordion-collapse collapse"
                    aria-labelledby="headingFour"
                  >
                    <div className="accordion-body">
                    KLIQ stands out by integrating multiple services in one platform, saving users the hassle of switching between different apps for their daily needs. Whether you need to send a package, pay bills, or manage waste, KLIQ brings everything into one convenient app.
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>


      <div className="container-fluid mt-5 "id="contactUs">
        <div className="container ">
          <div className="row g-5 align-items-center">
            <div
              className="col-lg-5 mx-auto text-center mb-5 wow fadeIn"
              data-wow-delay="0.3s"
            > 
              <h1 className="mb-4">Contact Us for Any Queries</h1>
              <p className="mb-4">
              For immediate assistance, you can also chat with us through the KLIQ app or visit our Help Center for FAQs and guides.
              We value your feedback and are always happy to assist with any issues or suggestions!
              </p>
            </div>
            <div className="col-lg-7 wow fadeIn" data-wow-delay="0.5s">
              <form action="">
                <div className="row g-4">
                  <div className="col-md-6">
                    <input
                      type="text"
                      className="form-control rounded-pill p-4"
                      placeholder="Your Name"
                      required
                    />
                  </div>
                  <div className="col-md-6">
                    <input
                      type="email"
                      className="form-control rounded-pill p-4"
                      placeholder="Your Email"
                      required
                    />
                  </div>
                  <div className="col-12">
                    <textarea
                      className="form-control rounded p-4"
                      rows="5"
                      placeholder="Message"
                      required
                    ></textarea>
                  </div>
                  <div className="col-12 text-end">
                    <a
                      href=""
                      className="btn btn-outline-light py-sm-3 px-sm-5 rounded-pill animated "
                    >
                      Send Message
                    </a>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HomePage;
